import { ScreenNames } from "./common.model";
import { stepKeys } from "./matTour.model";
import { EliteLexusIconComponent } from "../icons/elite-lexus-icon";
import {

    LucideHouse,
    LucideUsers,
    LucideBriefcase,
    LucideDollarSign,
    LucideTrendingUp,
    LucideAward,
    LucideFileText,
    LucideShare2,
    LucideClock,
    LucideClipboardList,
    LucideCalendarRange,
    LucideShieldCheck,
    LucideCalendarCheck,
    LucideChartColumn,
    LucideClipboardCheck
} from '@lucide/angular';

export interface MenuItem {
    route: string;
    icon?: any;
    label: string;
    menuId: number;
    tourAnchorId: string;
}

export const NavbarMenuItems: MenuItem[] = [{
    route: '/home',
    icon: LucideHouse,
    label: 'Home',
    menuId: 1,
    tourAnchorId: stepKeys['Home']
}
];
export const menuItems: Record<string, MenuItem> = {
    [ScreenNames['staffMaster']]: {
        route: `/${[ScreenNames['staffMaster']]}`,
        icon: LucideUsers,
        label: 'Staff Master',
        menuId: 2,
        tourAnchorId: stepKeys['StaffMaster']
    },
    [ScreenNames['jobRoleSummary']]: {
        route: `/${[ScreenNames['jobRoleSummary']]}`,
        icon: LucideBriefcase,
        label: 'Job Role Summary',
        menuId: 3,
        tourAnchorId: stepKeys['JobRoleSummary']
    },
    [ScreenNames['dealerTrainingBilling']]: {
        route: `/${[ScreenNames['dealerTrainingBilling']]}`,
        icon: LucideDollarSign,
        label: 'Dealers Billing',
        menuId: 4,
        tourAnchorId: stepKeys['DealerTrainingBilling']
    },
    [ScreenNames['elevateBilling']]: {
        route: `/${[ScreenNames['elevateBilling']]}`,
        icon: LucideTrendingUp,
        label: 'Elevate Billing',
        menuId: 5,
        tourAnchorId: stepKeys['ElevateBilling']
    },
    [ScreenNames['eventBilling']]: {
        route: `/${[ScreenNames['eventBilling']]}`,
        icon: LucideCalendarRange,
        label: 'Event Billing',
        menuId: 6,
        tourAnchorId: stepKeys['EventBilling']
    },
    [ScreenNames['aseLexus']]: {
        route: `/${[ScreenNames['aseLexus']]}`,
        icon: LucideAward,
        label: 'ASE',
        menuId: 7,
        tourAnchorId: stepKeys['AseLexus']
    },
    [ScreenNames['lexusTurnoverReport']]: {
        route: `/${[ScreenNames['lexusTurnoverReport']]}`,
        icon: LucideFileText,
        label: 'Lexus Turnover Report',
        menuId: 8,
        tourAnchorId: stepKeys['LexusTurnoverReport']
    },
    [ScreenNames['pcSupport']]: {
        route: `/${[ScreenNames['pcSupport']]}`,
        icon: LucideAward,
        label: 'PC Support',
        menuId: 9,
        tourAnchorId: stepKeys['jobHistory']
    },
    [ScreenNames['distributionList']]: {
        route: `/${[ScreenNames['distributionList']]}`,
        icon: LucideShare2,
        label: 'Distribution List',
        menuId: 10,
        tourAnchorId: stepKeys['distributionList']
    },
    [ScreenNames['tenure']]: {
        route: `/${[ScreenNames['tenure']]}`,
        icon: LucideClock,
        label: 'Tenure',
        menuId: 11,
        tourAnchorId: stepKeys['tenure']
    },
    [ScreenNames['eventDashboard']]: {
        route: `/${[ScreenNames['eventDashboard']]}`,
        icon: LucideCalendarRange,
        label: 'Events Registration Dashboard',
        menuId: 12,
        tourAnchorId: stepKeys['eventDashboard']
    },
    [ScreenNames['eliteCertificationReport']]: {
        route: `/${ScreenNames['eliteCertificationReport']}`,
        icon: EliteLexusIconComponent,
        label: 'Elite Certification',
        menuId: 13,
        tourAnchorId: stepKeys['eliteCertificationReport']
    },
    [ScreenNames['impactAnalysis']]: {
        route: `/${ScreenNames['impactAnalysis']}`,
        icon: LucideTrendingUp,
        label: 'Impact Analysis',
        menuId: 14,
        tourAnchorId: stepKeys['impactAnalysis']
    },
    [ScreenNames['survey']]: {
        route: `/${ScreenNames['pasDashboard']}`,
        icon: LucideClipboardCheck,
        label: 'PAS - Pre Attendance Survey',
        menuId: 15,
        tourAnchorId: stepKeys['survey']
    },
    // [ScreenNames['dealerScorecard']]: {
    //     route: `/${ScreenNames['dealerScorecard']}`,
    //     icon: LucideChartColumn,
    //     label: 'Dealer Scorecard',
    //     menuId: 16,
    //     tourAnchorId: stepKeys['dealerScorecard']
    // },
    [ScreenNames['information']]: {
        route: `/${[ScreenNames['information']]}`,
        icon: LucideClipboardList,
        label: 'Information',
        menuId: 25,
        tourAnchorId: stepKeys['information']
    },
    // [ScreenNames['googleAnalytics']]: {
    //     route: `/${[ScreenNames['googleAnalytics']]}`,
    //     icon: LucideClipboardList,
    //     label: 'Lexus learn Analytics',
    //     menuId: 27,
    //     tourAnchorId: stepKeys['googleAnalytics']
    // },
}
export const SuperAdminMenu: MenuItem = {
    route: '/user_role_settings',
    icon: LucideShieldCheck,
    label: 'Access Control',
    menuId: 18,
    tourAnchorId: stepKeys['userRoleSettings']
}

export const EventAdminMenu: MenuItem = {
    route: `/${ScreenNames['eventAdmin']}`,
    icon: LucideCalendarCheck,
    label: 'Event Admin',
    menuId: 17,
    tourAnchorId: stepKeys['eventAdmin']
}
